import Gesture from '@mui/icons-material/Gesture'
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Button, CardActionArea, CardContent, Divider, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

export const CreateBoundary: FC<{ onUploadShapefile?: () => void; replace?: boolean }> = ({
  children,
  onUploadShapefile,
  replace = false,
}) => {
  const { t } = useTranslation('impact/MapLayerOverlay')
  const [, setParams] = useSearchParams({ step: 'initial' })
  return (
    <>
      <CardContent sx={{ padding: 3 }}>
        <Typography variant="h6" sx={{ marginBottom: 1 }}>
          {t('whichBoundaryType')}
        </Typography>
        {children}
        <Stack spacing={2} pt={2}>
          <Button
            onClick={() => setParams({ step: 'drawing' }, { replace })}
            color="secondary"
            variant="contained"
            style={{ pointerEvents: 'all' }}
            startIcon={<Gesture />}
            data-testid='drawBoundary'
          >
            {t('drawBoundary')}
          </Button>
          <Button
            onClick={
              onUploadShapefile
                ? onUploadShapefile
                : () => setParams({ step: 'loading' }, { replace })
            }
            color="secondary"
            variant="contained"
            style={{ pointerEvents: 'all' }}
            startIcon={<UploadFileIcon />}
            data-testid='uploadShapefile'
          >
            {t('uploadShapefile')}
          </Button>
          <Button
            onClick={() => setParams({ step: 'selectArea' }, { replace })}
            color="secondary"
            variant="contained"
            style={{ pointerEvents: 'all' }}
            startIcon={<PinDropOutlinedIcon />}
            data-testid='selectArea'
          >
            {t('selectArea')}
          </Button>
        </Stack>
      </CardContent>
      <Divider />
      <CardActionArea
        sx={{ padding: 2, display: 'flex', justifyContent: 'space-between' }}
        style={{ pointerEvents: 'none' }}
        component="div"
      >
        <Button
          onClick={() => setParams({ step: 'initial' })}
          variant="text"
          color="secondary"
          style={{ pointerEvents: 'all' }}
        >
          {t('cancel')}
        </Button>
      </CardActionArea>
    </>
  )
}
